import React, { Component } from 'react'

import EstimationStore from '../libs/EstimationStore'
import EstimationActions from '../libs/EstimationActions'

class CheckBox extends Component {
  constructor (props) {
    super(props)
    this.state = {
      bindingDataAttribute: this.props.bindingDataAttribute,
      data: this.props.getData(),
      listener: null
    }
  }
  componentDidMount () {
    this.setState({
      listener: EstimationStore.addListener('change', () => {
        this.setState({
          data: this.props.getData()
        })
      })
    })
  }
  componentWillUnmount () {
    if (this.state.listener) this.state.listener.remove()
  }
  getDataValue () {
    if (this.props.isList) {
      let listName = this.props.listName
      let index = this.props.index
      // alert(this.state.data[listName][index][this.state.bindingDataAttribute]);
      return this.state.data[listName][index][this.state.bindingDataAttribute]
    }
    return this.state.data[this.state.bindingDataAttribute]
  }
  changeData () {
    const changedValue = !this.getDataValue()
    if (this.props.isList) {
      let listName = this.props.listName
      let index = this.props.index
      EstimationActions.updateListInCurrentEstimation(listName, index, this.state.bindingDataAttribute, changedValue)
    } else {
      EstimationActions.updateCurrentEstimation(this.state.bindingDataAttribute, changedValue)
    }
  }
  render () {
    return (
      <input type='checkbox' ref='checkbox' checked={this.getDataValue()} id={this.props.idForLabel} onChange={this.changeData.bind(this)} style={{verticalAlign: 'initial'}} />
    )
  }
}

CheckBox.defaultProps = {isList: false, idForLabel: '', getData: EstimationActions.getCurrentEstimation}
export default CheckBox



// WEBPACK FOOTER //
// ./src/company_user/components/CheckBox.js